import styled from 'styled-components';

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  box-sizing: border-box;
  border-radius: 8px;

  font-size: 10px;
  line-height: 16px;
  height: 16px;
  width: 16px;
  font-weight: 700;
  font-family: var(--font-family-body);

  color: var(--white);
  background-color: var(--orange-70);
  vertical-align: text-bottom;
`;

export { Badge };
